import styled from "styled-components";
import theme from "../../style/theme";

interface Props {
  width: string;
  height: string;
  text: string;
  onClick: () => void;
  sx?: any;
}

export const TextWhiteButton: React.FC<Props> = ({
  width,
  height,
  text,
  onClick,
  sx,
}) => {
  return (
    <TextButton style={sx} width={width} height={height} onClick={onClick}>
      {text}
    </TextButton>
  );
};

interface TextButtonProps {
  width: string;
  height: string;
}

const TextButton = styled.button<TextButtonProps>`
  width: ${(props) => props.width}};
  height: ${(props) => props.height}};
  background: ${theme.palette.primitives.white};
  border-radius: 4px;
  border: none;
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.188rem;
  color: ${theme.palette.primitives.gray600};
  cursor: pointer;
`;
